import { KeyValue, KeyValueDefault } from '@/main/models/common';
import { InsurerFilterRequest } from '@/main/models/request/insurerRequest';

export enum InsuranceSublineTypes {
  GET_INSURANCE_SUBLINES = '@insuranceSubline/GET_INSURANCE_SUBLINES',
  SAVE_INSURANCE_SUBLINES = '@insuranceSubline/SAVE_INSURANCE_SUBLINES',
  RESET_REDUCER_INSURANCE_SUBLINES = '@insuranceSubline/RESET_REDUCER_INSURANCE_SUBLINES',
}

export interface InsuranceSublineState {
  readonly insuranceSublines: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly isolated: {
    [key: string]: {
      data: KeyValue[] | null;
      errorMessages: string[] | null;
      isError: boolean;
      isLoading: boolean;
    };
  };
}

export interface GetInsuranceSublines {
  type: typeof InsuranceSublineTypes.GET_INSURANCE_SUBLINES;
  payload: {
    keyReducer: string;
  };
}

export interface SaveInsuranceSublines {
  type: typeof InsuranceSublineTypes.SAVE_INSURANCE_SUBLINES;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}

export interface ResetReducerInsuranceSublines {
  type: typeof InsuranceSublineTypes.RESET_REDUCER_INSURANCE_SUBLINES;
}

export type InsuranceSublineActionTypes =
  | GetInsuranceSublines
  | SaveInsuranceSublines
  | ResetReducerInsuranceSublines;